import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
    'hello': 'hello, world',
    'index': {
        name: '首页',
        introduction: 'introduction',
        battle:'同心抗疫',
        cooperation: '国际合作',
        information: '媒体报道',
        about: '关于我们'
    },
    ...enLocale
}

export default en